module.exports = __webpack_public_path__ + "static/media/anshor.fd868a9d.jpeg";